import React, { useState, useEffect } from 'react'
import { View, useWindowDimensions, StyleSheet, Text, TouchableOpacity, Image, Dimensions, ScrollView, StatusBar } from 'react-native'
import { TabView, SceneMap, TabBar } from 'react-native-tab-view'
import BenefitsList from './benefitsList'
import BenefitsHistoryList from './benefitsHistoryList'
import styles from './benefitsTabsStyles'
import styles3 from './benefitsHomeStyles3'
import theme from '../../../theme'
import { LinealTabs, RoundedTabs } from '../customUtils/LinealTabs'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { LinearGradient } from 'expo-linear-gradient'

const Benefits = ({ points }) => (
    <View style={styles.container}>
        <BenefitsList points={points ? points : 0} />
    </View>
)

const Redimes = ({ dataRedeems }) => (
    <>
        <View style={styles.redimesModule}>
            <BenefitsHistoryList dataRedeems={dataRedeems} />
        </View>
    </>
)

const renderScene = SceneMap({
    benefits: Benefits,
    redimes: Redimes,
})

const BenefitCard = ({ points }) => {
    const { languageFile } = getLanguage()
    //console.log('🚀 ~ BenefitCard ~ points:', points)
    return (
        <LinearGradient
            style={styles3.container}
            colors={[theme.colors.linearGradientStart, theme.colors.linearGradientEnd]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
        >
            <View style={[styles3.feedbackAssetContainer]}>
                <Image style={styles3.feedbackAsset} source={require('../../../assets/benefitsPoints.png')} />
            </View>

            <View style={[styles3.levelKnowledgeBlock, styles3.alignStart]}>
                <View>
                    <View style={styles3.containerDataBaseline}>
                        <Text style={styles3.title}>{languageFile.your_points}</Text>
                        <Text style={styles3.value}>{points}</Text>
                    </View>

                    <Text style={[styles3.subtitle]}>{languageFile.points_can_be_exchanged}</Text>
                </View>
            </View>
        </LinearGradient>
    )
}

export default function BenefitsTabs({ dataRedeems, points }) {
    const layout = useWindowDimensions()

    const [index, setIndex] = React.useState(0)
    const [selectedIndex, setSelectedIndex] = React.useState(0)

    const [routes] = React.useState([
        { key: 'benefits', title: 'Beneficios' },
        { key: 'redimes', title: 'Historial' },
    ])

    const [tabs, setTabs] = React.useState([])

    const { languageFile } = getLanguage()

    useEffect(() => {
        setTabs([
            {
                name: languageFile.benefits_mayus,
                index: 0,
            },
            {
                name: languageFile.history,
                index: 1,
            },
        ])
    }, [])
    return (
        <>
            <RoundedTabs
                tabs={tabs}
                selectedIndex={selectedIndex}
                colorLGStart={theme.colors.linearGradientStart}
                colorLGEnd={theme.colors.linearGradientEnd}
                colorSelected={theme.colors.colorSecondary}
                colorUnselected={theme.colors.colorPrimary}
                color={theme.colors.darkGray}
                onSelectedTab={(index) => {
                    setSelectedIndex(index)
                }}
            />
            <BenefitCard points={points ? points : 0} />
            {(() => {
                switch (selectedIndex) {
                    case 0:
                        return <Benefits points={points ? points : 0} />
                    case 1:
                        return <Redimes dataRedeems={dataRedeems} />
                    default:
                        return <Text>{languageFile.there_was_a_mistake}</Text>
                }
            })()}
        </>
    )
}
